import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RegisterState {
  loading: boolean;
  error: string;
  success: boolean;
  successMsg: string;
  errorMsg: string;
  otpVerified: boolean;
  phoneVerified: boolean;
  signupCompleted: boolean;
}

const initialState: RegisterState = {
  loading: false,
  error: "",
  success: false,
  successMsg: "",
  errorMsg: "",
  otpVerified: false,
  phoneVerified: false,
  signupCompleted: false,
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    phoneVerificationRequest(state) {
      state.loading = true;
      state.error = "";
      state.errorMsg = "";
    },
    phoneVerificationSuccess(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = true;
      state.successMsg = action.payload;
      state.phoneVerified = true;
      state.error = "";
      state.errorMsg = "";
    },
    phoneVerificationError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
      state.errorMsg = action.payload;
      state.phoneVerified = false;
    },
    otpVerificationRequest(state) {
      state.loading = true;
      state.error = "";
      state.errorMsg = "";
    },
    otpVerificationSuccess(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = true;
      state.successMsg = action.payload;
      state.otpVerified = true;
      state.error = "";
      state.errorMsg = "";
    },
    otpVerificationError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
      state.errorMsg = action.payload;
      state.otpVerified = false;
    },
    signupRequest(state) {
      state.loading = true;
      state.error = "";
      state.errorMsg = "";
    },
    signupSuccess(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = true;
      state.successMsg = action.payload;
      state.signupCompleted = true;
      state.error = "";
      state.errorMsg = "";
    },
    signupError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
      state.errorMsg = action.payload;
      state.signupCompleted = false;
    },
    resetRegisterState(state) {
      state.loading = false;
      state.error = "";
      state.success = false;
      state.successMsg = "";
      state.errorMsg = "";
      state.otpVerified = false;
      state.phoneVerified = false;
      state.signupCompleted = false;
    },
  },
});

export const {
  phoneVerificationRequest,
  phoneVerificationSuccess,
  phoneVerificationError,
  otpVerificationRequest,
  otpVerificationSuccess,
  otpVerificationError,
  signupRequest,
  signupSuccess,
  signupError,
  resetRegisterState,
} = registerSlice.actions;

export default registerSlice.reducer;



